import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  user: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('user');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.user.length > 0 ? action.user : [];  
  return updateObject(state, {
    user: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, user:[] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_START:
      return fetchStart(state);
    case actionTypes.FETCH_USER_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_USER_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;